import React from 'react'
import "./footer.style.css"

function Footer() {
    return (
        <div className="Footer">
            <p><span>Made by</span> DylanDev</p>
        </div>
    )
}

export default Footer